<div class="offcanvas-header">
  <h5 class="offcanvas-title">AI Search Preview</h5>
  <button type="button" class="btn-close text-reset" aria-label="Close"
    (click)="activeOffcanvas.dismiss('Cross click')"></button>
</div>
<div class="offcanvas-body" style="background-color: oklch(0.967 0.003 264.542);">
  <div class="d-flex justify-content-center">

    <div class="d-flex flex-column align-items-center w-100 mx-4">

      <div class="w-100">
        <app-search-input [loading]="loading()" (searchChange)="makeSearch($event)"></app-search-input>
      </div>

      @if (followUps()) {
      <div class="w-100 pt-4">
        <app-followup-history [followUpLoading]="loading()" [followupHistory]="followUps()"></app-followup-history>
      </div>
      }

      @if (query()) {
      <div class="d-flex flex-column gap-2 w-100">
        <app-answer [loading]="loading() || followupLoading()" [answer]="answer()" [query]="query()" [answerWithCitations]="textWithCitations" [results]="searchResults()">
          <div class="mt-2">
            <app-search-input [loading]="followupLoading()" (searchChange)="makeFollowup($event)" [isFollowUp]="true" />
          </div>
        </app-answer>
      </div>
      }

      @if (searchResults().length > 0) {
      <div #results class="w-100 mt-4">
        <app-results [searchResults]="searchResults()"></app-results>
      </div>
      }
    </div>

  </div>
</div>